<template>
  <v-container class="white-wrapper" fluid>
    <!-- <phone-overlay :show="!auth_sms" :back="true"></phone-overlay> -->
    <div
      style="max-width:25rem;margin:0 auto;height:100%;display:flex;flex-direction:column;justify-content:space-between;padding: 0 1rem;"
    >
      <!-- <div class="config-title">
        <router-link to="/config">
          <v-btn icon class="back-icon" large>
            <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
          </v-btn>
        </router-link>
        <div class="text-h6 font-weight-bold">
          {{ $t('config.swapCoin') }}
        </div>
      </div> -->
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-select
          class="select-wrapper"
          :items="fromWallet"
          label="From"
          :placeholder="$t('swap.errCoin')"
          :rules="coinRules"
          v-model="fromType"
          required
          @change="onChangeFromtype"
        >
          <template slot="selection" slot-scope="{ item }">
            <div class="d-flex select-item justify-space-between px-4">
              <div class="d-flex align-center justify-center">
                <img
                  class="mr-2"
                  style="width:1.5rem;"
                    :src="require(`@/assets/svg/${item.name}-logo.svg`)"  
                />
                <div class="font-weight-black d-flex align-center">
                  {{ item.name }}
                </div>
              </div>
              <div class="font-weight-medium d-flex align-center justify-end">
                {{ comma(item.balance) }}
              </div>
            </div>
          </template>

          <template slot="item" slot-scope="{ item }">
            <div class="d-flex select-item justify-space-between">
              <div class="d-flex align-center justify-center">
                <img
                  class="mr-2"
                  style="width:1.5rem;"
                  :src="require(`@/assets/svg/${item.name}-logo.svg`)"
                />
                <div class="font-weight-black d-flex align-center">
                  {{ item.name }}
                </div>
              </div>
              <div class="font-weight-medium d-flex align-center justify-end">
                {{ comma(item.balance) }}
              </div>
            </div>
          </template>
        </v-select>

        <v-text-field
          ref="from"
          :class="fromAmount ? 'swap-input-wrapper' : 'select-wrapper'"
          type="number"
          :label="$t('swap.amount')"
          :placeholder="$t('swap.errAmount')"
          v-model="fromAmount"
          :rules="amountRules"
          @keypress="onKeydown"
          required
        >
        </v-text-field>
        <div class="max-btn">
          <v-btn
            small
            text
            color="primary"
            :disabled="!fromType"
            @click="onClickMax"
          >
            최대
          </v-btn>
        </div>
        <div class="swap-icon">
          <v-icon>mdi-swap-vertical</v-icon>
        </div>

        <v-select
          class="select-wrapper"
          :items="toWallet"
          label="To"
          :placeholder="$t('swap.errCoin')"
          :rules="coinRules"
          v-model="toType"
          required
          :disabled="!fromType"
        >
          <template slot="selection" slot-scope="{ item }">
            <div class="d-flex select-item">
              <v-col class="d-flex align-center justify-center" cols="1">
                <img
                  style="width:1.2rem;"
                  srca="require(`@/assets/svg/${item.name}-logo.svg`)"
                  :src=imgSrc(item.name)

                />
              </v-col>
              <v-col class="font-weight-medium d-flex align-center" cols="2">
                {{ item.name }}
              </v-col>
              <v-col class="font-weight-medium d-flex align-center justify-end">
                {{ comma(item.balance) }}
                {{ item.name }}
              </v-col>
            </div>
          </template>
          
          <template slot="item" slot-scope="{ item }">
            <div class="d-flex select-item">
              <v-col class="d-flex align-center justify-center" cols="1">
                <img
                  style="width:1.2rem;"
                  srca="require(`@/assets/svg/${item.name}-logo.svg`)"
                  :src=imgSrc(item.name)
                />
              </v-col>
              <v-col class="font-weight-medium d-flex align-center" cols="2">
                {{ item.name }}
              </v-col>
              <v-col class="font-weight-medium d-flex align-center justify-end">
                {{ comma(item.balance) }}
                {{ item.name }}
              </v-col>
            </div>
          </template>

        </v-select>
        <v-text-field
          class="swap-input-wrapper"
          :label="$t('swap.amount')"
          :placeholder="$t('swap.errAmount')"
          v-model="toAmount"
          readonly
        >
          {{ calc(fromAmount) }}
        </v-text-field>
      </v-form>

      <!-- {{loading}} / {{ disabled}} / {{availableToken}} / {{valid}} / {{ isAvailableFee }}  -->
{{ this.solBalance }} // 
{{ this.fee }} 
      <div>
        <!-- <v-btn class="font-weight-bold" @click="reset" x-large block>
            {{ $t('swap.reset') }}
          </v-btn> -->
        <v-btn
          class="font-weight-bold mb-4"
          color="primary"
          @click="confirmDialog = true"
          x-large
          block
          :disabled="
            loading || disabled || !availableToken || !valid || !isAvailableFee
          "
        >
          {{ $t('swap.requestSwap') }}
        </v-btn>


      </div>
    </div>

    <v-bottom-sheet v-model="confirmDialog" scrollable>
      <v-card class="rounded-lg" style="min-height: 50vh;">
        <v-card-title></v-card-title>
        <v-card-text class="type-wrapper" v-if="fromType && toType">
          <div class="sheet-title">예상내역</div>
          <div class="sheet-row">
            <span>From.{{fromType}}</span>
            <span>{{ `${comma(fromAmount)} ${upperFrom}` }}</span>
          </div>
          <div class="sheet-row">
            <span>To.{{toType}}</span>
            <span>{{ `${comma(toAmount)} ${upperTo}` }}</span>
          </div>
          <v-divider class="my-5"></v-divider>
          <div class="sheet-row">
            <span>스왑 경로</span>
            <div class="d-flex align-center">
              <div class="d-flex align-center">
                <div class="logo-circle">
                  <img
                    style="width:0.8rem;"
                    srca="require(`@/assets/svg/${item.name}-logo.svg`)"
                    :src="require(`@/assets/svg/${upperFrom}-logo.svg`)"
                    
                  />
                </div>
                {{ upperFrom }} 
              </div>
              <img
                style="width:0.7rem;margin:0 1rem;"
                :src="require(`@/assets/icon/double-arrow.svg`)"
              />
              <div class="d-flex align-center">
                <div class="logo-circle">
                  <img
                    style="width:0.8rem;"
                    srca="require(`@/assets/svg/${item.name}-logo.svg`)"
                    :src="require(`@/assets/svg/${upperTo}-logo.svg`)"
                  />
                </div>
                {{ upperTo }}
              </div>
            </div>
          </div>
          <div class="sheet-row">
            <span>스왑 비율</span>
            <span>{{ `1 ${upperTo} = ${perToken} ${upperFrom}` }}</span>
          </div>
          <div :class="`sheet-row${isAvailableFee ? '' : ' error--text'}`">
            <span>수수료</span>
            <span>{{
              `${expectFee} ${fromType === 'staika' ? 'SOL' : 'ETH'}`
            }}</span>
          </div>
        </v-card-text>

        <v-btn
          color="primary"
          fixed
          style="bottom:0;"
          tile
          block
          large
          height="56px"
          @click="submitSwap"
          :disabled="!availableToken || !isAvailableFee || loading"
        >
          신청하기
        </v-btn>
      </v-card>
    </v-bottom-sheet>

    <v-dialog v-model="messageModal" max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text v-html="message"> </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="messageModal = false">
            {{ $t('swap.messageModal.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BigNumber from 'bignumber.js'
import PhoneOverlay from '../../components/PhoneOverlay.vue'

export default {
  components: { PhoneOverlay },
  data: () => ({
    fee: null,
    valid: true,
    fromType: null,
    toAddress: '',
    is_swap : true ,
    configId: null,
    toType: null,
    fromAmount: null,
    toAmount: 0,
    amountRules: [(v) => !!v || '', (v) => v > 0 || ''],
    coinRules: [(v) => !!v || ''],
    messageModal: false,
    message: null,
    confirmDialog: false,
    fee: null,
    noConfig: false,
    hash: null
  }),
  computed: {
    auth_sms() {
      return true ; 
      return this.$store.getters.user.auth_sms === 'Y' ? true : false
    },
    myWalletAdress() {
      return this.$store.getters.user.wallet_address
    },
    fromWallet() {
      // console.log("dev: " ,  this.$store.getters.wallet ) ; 
      return this.$store.getters.wallet.filter((item) => item.name === 'ETH' ||item.name === 'USDT' ||item.name === 'STAIKA' ||item.name === 'CCC' ||item.name === 'LSS'   )

      return this.$store.getters.wallet
    },
    solBalance() {
      return this.$store.getters.wallet.filter((i) => i.name === 'SOLANA')[0]
        .balance
    },    
    ethBalance() {
      return this.$store.getters.wallet.filter((i) => i.name === 'ETH')[0]
        .balance
    },
    toWallet() {
      // // console.log("To : " , this.$store.getters.wallet.filter((item) => item.name === 'CCC' ||item.name === 'LSS'  )  )  ;
      return this.$store.getters.wallet.filter((item) => item.name === 'CCC' ||item.name === 'LSS'  ||item.name === 'EUR'   )

      // if (this.fromType === 'plp')
      //   return this.$store.getters.wallet.filter((item) => item.name === 'PLI')
      // if (this.fromType === 'pli')
      //   return this.$store.getters.wallet.filter((item) => item.name === 'PLP')
      // return this.$store.getters.wallet.filter(
      //   (item) => item.name === 'PLP' || item.name === 'PLI'
      // )
    },
    upperFrom() {
      return this.fromType ? this.fromType.toUpperCase() : null
    },
    upperTo() {
      return this.toType ? this.toType.toUpperCase() : null
    },
    prices() {
      return this.$store.getters.prices
    },
    loading() {
      return this.$store.getters.loading
    },
    disabled() {
      return !this.fromType || !this.toType || this.noConfig
    },
    fromBalance() {
      return this.fromType
        ? this.fromWallet.filter((item) => item.value === this.fromType)[0]
            .balance
        : 0
    },
    availableToken() {
      if (!this.fromType || !this.fromAmount || this.fromAmount <= 0)
        return false
console.log(
  BigNumber(this.fromAmount).toNumber()  , 
        BigNumber(this.fromBalance).toNumber() , 

BigNumber(this.fromAmount).toNumber() <=
        BigNumber(this.fromBalance).toNumber() ) 
      return (
        BigNumber(this.fromAmount).toNumber() <=
        BigNumber(this.fromBalance).toNumber()
      )
    },
    perToken() {
///      // console.log(  BigNumber('1').times(this.prices[`price_${this.toType}`]).toFixed(8)   , this.prices[`price_${this.toType}`] ) ;
///      // console.log(  BigNumber('1').times(this.prices[`price_${this.toType}`]) .div(this.prices[`price_${this.fromType}`]).toFixed(8)   , this.prices[`price_${this.fromType}`] ) ;

      return this.comma(
        BigNumber('1')
          .times(this.prices[`price_${this.toType}`])
          .div(this.prices[`price_${this.fromType}`])
          .toFixed(8)
      )
    },
    expectFee() {


      // this.fromType === 'pli'
      //   ? this.fromAmount
      //     ? BigNumber(this.fromAmount)
      //         .div(BigNumber('1000'))
      //         .toFixed(2, 1)
      //     : 0
      //   : (this.fee * 60000) / 10000000000
      if( this.fromType === 'staika' ) {
        this.fee = 0.000005  ; //  BigNumber(0.000005) ; 
        return 0.000005 ; // BigNumber(0.000005)  ;

      }else{
        return this.fromType === 'pli'
        ? this.fromAmount
          ? BigNumber(this.fromAmount)
              .div(BigNumber('1000'))
              .toFixed(2, 1)
          : 0
        : (this.fee * 60000) / 10000000000
      }

    },
    isAvailableFee() {

      console.log( )  ; 
      if( this.fromType == 'staika' )  {
        return this.expectFee <= this.solBalance
      } else {
        if ( this.fromType === 'eth' || this.fromType === 'pli' ) {
          return BigNumber(this.fromBalance).isGreaterThanOrEqualTo(
            BigNumber(this.fromAmount).plus(BigNumber(this.expectFee))
          )
        }     

        return this.expectFee <= this.ethBalance

      } 
      // if ( this.fromType === 'eth' || this.fromType === 'pli' || this.fromType === 'ccc' || this.fromType === 'lss'  ) {


    }
  },
  created() {
    
    this.$store.commit('loading', true)
    this.$store.dispatch('FETCH_PRICES')
    // this.$store.dispatch('FETCH_WALLET')    
    // console.log( "prices :: "  ,this.$store.prices   )

    this.amountRules = [
      (v) => !!v || '스왑하실 수량을 확인해주세요.',
      (v) => v > 0 || '스왑하실 수량을 확인해주세요.'
    ]
    this.coinRules = [(v) => !!v || this.$t('swap.errCoin')]
    this.$store
      .dispatch('GETGAS')
      .then((res) => {
        // console.log("res.data.fast" , res   )

        if (res.data && res.data.fast) {
          // console.log("res.data.fast", res.data.fast )
          this.fee = res.data.fast

          return this.$store.dispatch('api_config', {
            column: ['id', 'admin_address']
          })
        } else throw res
      })
      .then((response) => {
        this.$store.commit('loading', false)
        if (response.status === 200) {
          this.toAddress = response.data.admin_address
          this.configId = response.data.id
        } else throw response
      })
      .catch((err) => {
        this.noConfig = true
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('errorServer'),
          timeout: 3000
        })
      })
  },
  methods: {
    imgSrc(item) {
      // console.error( item ) ; 
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      }
      return src
    },     
    calc(i) {
     //  // console.log( "methods :: calc : " , i ,  this.toType  , this.prices[`price_${this.fromType}`] , this.fromType  , this.prices  )

      
      if (this.toType && this.fromAmount && this.fromType) {
        // // console.log(this.prices, this.fromAmount, this.fromType, i)
        if (this.toType === 'pli' || this.toType === 'eur'  ) {
          this.toAmount = BigNumber(i)
            .times(this.prices[`price_${this.fromType}`])
            .div(this.prices[`price_${this.toType}`])
            .toFixed(2)
        } else {
          this.toAmount = BigNumber(i)
            .times(this.prices[`price_${this.fromType}`])
            .div(this.prices[`price_${this.toType}`])
            .toFixed(8)
        }
      } else {
        this.toAmount = 0
      }
      
      return this.toAmount
    },
    onChangeFromtype() {

    // // console.log( this.fromType  )

     if (this.fromType === 'eth') {
        this.amountRules = [
          (v) => !!v || '스왑하실 수량을 확인해주세요.',
          (v) => v >= 0.01 || '0.01 ETH 이상 환전 가능합니다.'
        ]
      } else if (this.fromType === 'usdt') {
        this.amountRules = [
          (v) => !!v || '스왑하실 수량을 확인해주세요.',
          (v) => v >= 40 || '40 USDT 이상 환전 가능합니다.'
        ]
      }    
      this.fromAmount = null
      
      
      /*
      if (this.fromType === 'plp') this.toType = 'pli'
      else this.toType = 'plp'

      if (this.fromType === 'pli') {
        this.amountRules = [
          (v) => !!v || '스왑하실 수량을 확인해주세요.',
          (v) => v >= 10000 || this.$t('point.amountError')
        ]
      } else if (this.fromType === 'eth') {
        this.amountRules = [
          (v) => !!v || '스왑하실 수량을 확인해주세요.',
          (v) => v >= 0.02 || '0.02 ETH 이상 환전 가능합니다.'
        ]
      } else if (this.fromType === 'usdt') {
        this.amountRules = [
          (v) => !!v || '스왑하실 수량을 확인해주세요.',
          (v) => v >= 40 || '40 USDT 이상 환전 가능합니다.'
        ]
      } else {
        this.amountRules = [
          (v) => !!v || '스왑하실 수량을 확인해주세요.',
          (v) => v > 0 || '스왑하실 수량을 확인해주세요.'
        ]
      }      
      this.fromAmount = null
      */ 

    },
  
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()

      let regx = /^\d*[.]\d{8}$/
      if (this.fromType === 'usdt') regx = /^\d*[.]\d{6}$/
      if (this.fromType === 'pli' || this.fromType === 'plp')
        regx = /^\d*[.]\d{2}$/
      const _value = e.target.value

      if (regx.test(_value)) e.preventDefault()
    },
    // onClickMask(type) {
    //   if (this.fromType) {
    //     const len = this.fromAmount.length
    //     if (this.$refs[type].setSelectionRange !== undefined) {
    //       el.setSelectionRange(len, len)
    //     }
    //   }
    //   this.$refs[type].focus()
    // },
    onClickMax() {
      if (this.fromType === 'pli') {
        const pli = this.fromBalance
        const tmp = BigNumber(pli)
          .times(BigNumber(1000 / 1001))
          .toFixed(2, 0)
        const fee = BigNumber(tmp)
          .div(BigNumber('1000'))
          .toFixed(2, 1)
        if (tmp + fee > pli) {
          this.fromAmount = BigNumber(pli)
            .times(BigNumber(1000 / 1001))
            .toFixed(2, 1)
        } else {
          this.fromAmount = tmp
        }
      } else if (this.fromType === 'eth') {
        this.fromAmount = BigNumber(this.fromBalance - this.expectFee).toFixed(
          8,
          1
        )
      } else {
        this.fromAmount = this.fromBalance
      }
    },
    submitSwap() {
 

      this.$store.commit('loading', true) ; 
      this.confirmDialog = false ;
      alert(this.fromType);
      switch (this.fromType) {
         
        case 'plp':
          this.$store
            .dispatch('AVAIL_TOKEN', {
              token: 'plp'
            })
            .then((res) => {
              const data = res.data

              const sum = BigNumber(data.locked.sum)
                .plus(BigNumber(data.staking.sum))
                .plus(BigNumber(data.pending.SUM))
                .plus(BigNumber(this.fromAmount))
                .toNumber()
              // if (sum > this.fromBalance) throw { error: 'insufficient' }

              const params = {
                amount: this.fromAmount,
                fee: this.fee,
                toAddress: this.toAddress,
                sendType: this.fromType
              }
              return this.$store.dispatch('send_transaction', params)
            })
            .then((res) => {
              // // console.log('res.data', res.data);
              if (res.data && res.data.status) {
                // 성공시 처리
                this.hash = res.data.hash
                const params = {
                  configId: this.configId,
                  fromAmount: this.fromAmount,
                  fromType: this.fromType,
                  hash: res.data.hash,
                  priceId: this.prices.id,
                  toAmount: this.toAmount,
                  toType: this.toType
                }
                // // console.log('uswap: ', params);
                return this.$store.dispatch('user_swap', params)
              } else throw res
            })
            .then((res) => {
              // // console.log('uswap: ', res);
              if (res.data && res.data.status) {
                this.$store.commit('loading', false)
                this.$router.replace({
                  name: 'swap-success',
                  params: { hash: res.data.hash }
                })
                this.$refs.form.reset()
              } else throw 'db'
            })
            .catch((err) => {
              // // console.log(err)
              this.$store.commit('loading', false)
              if (err.error && err.error.indexOf('insufficient') !== -1) {
                this.message = this.$t('swap.messageModal.amountFail')
                this.messageModal = true
              } else if (err.error) {
                this.message = `${this.$t('swap.messageModal.fail')}<br/>(${
                  err.error
                })`
                this.messageModal = true
              } else {
                this.$store.dispatch('toast', {
                  toast: true,
                  toast_msg: this.$t('errorServer'),
                  timeout: 3000
                })
              }
              this.$refs.form.reset()
            })
          break
        case 'eth':
        case 'usdt':
        case 'staika':


          let sum = 0 ;           
          if (this.fromType === 'eth') {
            sum = BigNumber(this.fee)
              .times(60000)
              .div(10000000000)
              .plus(this.fromAmount)
              .toNumber() ;

            if (sum > this.fromBalance) throw { error: 'insufficient' }

          } else if (this.fromType === 'usdt') {  

            sum = BigNumber(this.fromAmount)   ; 
            if (sum > this.fromBalance) throw { error: 'insufficient' }

          } else if (this.fromType === 'staika') { 
            
            if ( BigNumber(this.fee) > this.solBalance) throw { error: 'insufficient' } ; 
            if ( BigNumber(this.fromAmount) > this.fromBalance) throw { error: 'insufficient' } ;  

          }


     
          

          const params = {
            amount: this.fromAmount,
            fee: this.fee,
            toAddress: this.toAddress,
            toId: this.toAddress,
            is_swap : this.is_swap , 
            sendType: this.fromType
          } 
          console.log("params : " , params )  ;

          return  ; 
          this.$store
            .dispatch('send_transaction', params)
            .then((res) => {
              // console.log('res.data', res.data);
              if (res.data && res.data.status) {
                // 성공시 처리
                this.hash = res.data.hash
                const params = {
                  configId: this.configId,
                  fromAmount: this.fromAmount,
                  fromType: this.fromType,
                  hash: res.data.hash,
                  priceId: this.prices.id,
                  toAmount: this.toAmount,
                  toType: this.toType
                }
                // // console.log('uswap: ', params);
                return this.$store.dispatch('user_swap', params)
              } else throw res
           })
            .then((res) => {
              // console.log('uswap: ', res);
              if (res.data && res.data.status) {
                this.$store.commit('loading', false)
                this.$router.replace({
                  name: 'swap-success',
                  params: { hash: res.data.hash }
                })
                this.$refs.form.reset()
              } else throw 'db'
            })
            .catch((err) => {
               // console.log(err)
              this.$store.commit('loading', false)
              if (err.error && err.error.indexOf('insufficient') !== -1) {
                this.message = this.$t('swap.messageModal.amountFail')
                this.messageModal = true
              } else if (err.error) {
                this.message = `${this.$t('swap.messageModal.fail')}<br/>(${
                  err.error
                })`
                this.messageModal = true
              } else if (err === 'db') {
                this.message = `스왑신청이 실패하였습니다. 관리자에게 문의해주세요.`
                this.messageModal = true
              } else {
                this.$store.dispatch('toast', {
                  toast: true,
                  toast_msg: this.$t('errorServer'),
                  timeout: 3000
                })
              }
              this.$refs.form.reset()
            })
          break
      }
    },
    reset() {
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-item .col {
  padding: 0 0.5rem;
}
.select-item {
  width: 100%;
  color: #121212;
}
.swap-icon {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
}
.bottom-btn-left {
  position: fixed;
  width: 50%;
  left: 0;
  bottom: 55px;
}
.bottom-btn-right {
  position: fixed;
  width: 50%;
  left: 50%;
  bottom: 55px;
}
.label-wrapper {
  font-weight: bold;
  font-size: 0.85rem;
  margin-left: 1rem;
}
.max-btn {
  display: flex;
  justify-content: flex-end;
  height: 0;
  transform: translateY(-15px);
}
// .mask-wrapper {
//   background-color: #fff;
//   margin: 0 13px 0 12px;
//   text-align: right;
//   transform: translateY(-56px);
// }
// .placeholder-wrapper {
//   text-align: left;
//   color: #797979;
// }
.bottom-btn-right.theme--light.v-btn.v-btn--disabled,
.bottom-btn-right.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #c8bae8 !important;
  color: #fff !important;
}
.sheet-title {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1.2rem;
}
.sheet-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.8rem auto;
}
.logo-circle {
  background-color: #e2e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 0.2rem;
}
</style>
